import mock from '../mock'

// ** Utils
import { paginateArray } from '../utils'

// Avatar Import
import avatar1 from '@src/assets/images/avatars/1-small.png'
import avatar2 from '@src/assets/images/avatars/2-small.png'
import avatar3 from '@src/assets/images/avatars/3-small.png'
import avatar4 from '@src/assets/images/avatars/4-small.png'
import avatar5 from '@src/assets/images/avatars/5-small.png'
import avatar6 from '@src/assets/images/avatars/6-small.png'
import avatar7 from '@src/assets/images/avatars/7-small.png'
import avatar8 from '@src/assets/images/avatars/8-small.png'
import avatar9 from '@src/assets/images/avatars/9-small.png'
import avatar10 from '@src/assets/images/avatars/10-small.png'

const data = {
    invoices: [
    {
        id: 4987,
        issuedDate: '13 Dec 2019',
        client: {
            address: 'Vivamus Sagittis Bibendum',
            company: 'Erat Volutpat',
            companyEmail: 'don85@johnson.com',
            country: 'Dapibus Ac',
            contact: '(616) 865-4180',
            name: 'Aenean Commodo Ligula'
        },
        service: 'Eget Dolor Aenean',
        total: 3428,
        avatar: '',
        invoiceStatus: 'Massa Cum Sociis',
        balance: '$724',
        dueDate: '23 Apr 2019'
    },
    {
        id: 4988,
        issuedDate: '17 Jul 2019',
        client: {
            address: 'Nullam Dictum Felis',
            company: 'Eu Pedemontes Nisl',
            companyEmail: 'brenda49@taylor.info',
            country: 'Nisi Viverra Arcu',
            contact: '(226) 204-8287',
            name: 'Morbi Vehicula'
        },
        service: 'Pellentesque Eu Tincidunt',
        total: 5219,
        avatar: avatar10,
        invoiceStatus: 'Tortor Neque Adipiscing',
        balance: 0,
        dueDate: '15 Dec 2019'
    },
    {
        id: 4989,
        issuedDate: '19 Oct 2019',
        client: {
            address: 'Diam Maecenas Ultricies',
            company: 'Mauris Magna Quisque',
            companyEmail: 'smithtiffany@powers.com',
            country: 'Venenatis Tellus In',
            contact: '(955) 676-1076',
            name: 'Metus Vulputate Eu'
        },
        service: 'Scelerisque Fermentum Dui',
        total: 3719,
        avatar: avatar1,
        invoiceStatus: 'Faucibus Pulvinar',
        balance: 0,
        dueDate: '03 Nov 2019'
    },
    {
        id: 4990,
        issuedDate: '06 Mar 2020',
        client: {
            address: 'Elementum Sagittis Vitae',
            company: 'Et Leo Duis',
            companyEmail: 'mejiageorge@lee-perez.com',
            country: 'Ultricies Leo Integer',
            contact: '(832) 323-6914',
            name: 'Malesuada Pellentesque Elite'
        },
        service: 'Ullamcorper Sit Amet',
        total: 4749,
        avatar: avatar9,
        invoiceStatus: 'Risus Commodo Viverra',
        balance: 0,
        dueDate: '11 Feb 2020'
    },
    {
        id: 4991,
        issuedDate: '08 Feb 2020',
        client: {
            address: 'Maecenas Sed Enim',
            company: 'Ut Venenatis Tellus',
            companyEmail: 'brandon07@pierce.com',
            country: 'In Cursus Turpis',
            contact: '(970) 982-3353',
            name: 'Magna Quisque Porttitor'
        },
        service: 'Vel Turpis Nunc',
        total: 4056,
        avatar: avatar10,
        invoiceStatus: 'Eget Nunc Scelerisque',
        balance: '$815',
        dueDate: '30 Jun 2019'
    },
    {
        id: 4992,
        issuedDate: '26 Aug 2019',
        client: {
            address: 'Viverra Accumsan In',
            company: 'Nisl Tincidunt Eget',
            companyEmail: 'guerrerobrandy@beasley-harper.com',
            country: 'Nullam Non Nisi',
            contact: '(511) 938-9617',
            name: 'Est Sit Amet'
        },
        service: 'Facilisis Mauris Sit',
        total: 2771,
        avatar: '',
        invoiceStatus: 'Amet Porttitor Eget',
        balance: 0,
        dueDate: '24 Jun 2019'
    },
    {
        id: 4993,
        issuedDate: '17 Sep 2019',
        client: {
            address: 'Dolor Magna Eget',
            company: 'Est Lorem Ipsum',
            companyEmail: 'williamshenry@moon-smith.com',
            country: 'Dolor Sit Amet',
            contact: '(504) 859-2893',
            name: 'Consectetur Adipiscing Elit'
        },
        service: 'Pellentesque Diam Volutpat',
        total: 2713,
        avatar: '',
        invoiceStatus: 'Commodo Sed Egestas',
        balance: '$407',
        dueDate: '22 Nov 2019'
    },
    {
        id: 4994,
        issuedDate: '11 Feb 2020',
        client: {
            address: 'Eget Nunc Lobortis',
            company: 'Mattis Ullamcorper',
            companyEmail: 'margaretharvey@russell-murray.com',
            country: 'Venenatis Auctor',
            contact: '(758) 403-7718',
            name: 'Dui Sapien Eget'
        },
        service: 'Mi Proin Sed',
        total: 4309,
        avatar: avatar9,
        invoiceStatus: 'Libero Nunc Consequat',
        balance: '-$205',
        dueDate: '10 Feb 2020'
    },
    {
        id: 4995,
        issuedDate: '26 Jan 2020',
        client: {
            address: 'Interdum Posuere Lorem',
            company: 'Ipsum Dolor Sit',
            companyEmail: 'dianarodriguez@villegas.com',
            country: 'Amet Consectetur Adipiscing',
            contact: '(292) 873-8254',
            name: 'Elit Sed Vulputate'
        },
        service: 'Mia Bibendum Arcu',
        total: 3367,
        avatar: avatar2,
        invoiceStatus: 'Vitae Elementum Curabitur',
        balance: 0,
        dueDate: '24 Dec 2019'
    },
    {
        id: 4996,
        issuedDate: '15 Jan 2020',
        client: {
            address: 'Vitae Auctor Eu',
            company: 'Augue Ullamcorper',
            companyEmail: 'bwilson@norris-brock.com',
            country: 'Morbi Tincidunt',
            contact: '(956) 803-2008',
            name: 'Ornare Arcu Dui'
        },
        service: 'Vivamus Arcu Felis',
        total: 4776,
        avatar: avatar9,
        invoiceStatus: 'Bibendum At Varius',
        balance: '$305',
        dueDate: '02 Jun 2019'
    },
    {
        id: 4997,
        issuedDate: '27 Sep 2019',
        client: {
            address: 'Velit Sed Ullamcorper',
            company: 'Morbi Tristique',
            companyEmail: 'markcampbell@bell.info',
            country: 'Senectus Et Netus',
            contact: '(716) 962-8635',
            name: 'Et Malesuada Fames'
        },
        service: 'Ac Turpis Egestas',
        total: 3789,
        avatar: avatar4,
        invoiceStatus: 'Integer Eget Aliquet',
        balance: '$666',
        dueDate: '18 Mar 2020'
    },
    {
        id: 4998,
        issuedDate: '31 Jul 2019',
        client: {
            address: 'Nibh Praesent Tristique',
            company: 'Magna Sit Amet',
            companyEmail: 'mary61@rosario.com',
            country: 'Purus Gravida',
            contact: '(523) 449-0782',
            name: 'Quis Vel Turpis'
        },
        service: 'Nunc Consectetur',
        total: 5200,
        avatar: avatar5,
        invoiceStatus: 'Lorem Donec Massa',
        balance: 0,
        dueDate: '17 Jan 2020'
    },
    {
        id: 4999,
        issuedDate: '14 Feb 2020',
        client: {
            address: 'Sapien Nec Sagittis',
            company: 'Aliquam Malesuada Bibendum',
            companyEmail: 'sean22@cook.com',
            country: 'Arcu Cursus Vitae',
            contact: '(583) 470-8356',
            name: 'Consectetur Purus Ut'
        },
        service: 'Faucibus Turpis In',
        total: 4558,
        avatar: avatar7,
        invoiceStatus: 'Eu Mi Bibendum',
        balance: 0,
        dueDate: '01 Oct 2019'
    },
    {
        id: 5000,
        issuedDate: '21 May 2019',
        client: {
            address: 'Neque Egestas Congue',
                company: 'Lambert-Thomas Group',
                companyEmail: 'mccoymatthew@lopez-jenkins.net',
                country: 'Vanuatu',
                contact: '(366) 906-6467',
                name: 'Ryan Meyer'
            },
            service: 'Template Customization',
            total: 3503,
            avatar: avatar9,
            invoiceStatus: 'Paid',
            balance: 0,
            dueDate: '22 May 2019'
        },
        {
        id: 5001,
        issuedDate: '30 Jun 2019',
        client: {
            address: 'Vestibulum Ante Ipsum',
            company: 'Primis In Faucibus',
            companyEmail: 'novakshannon@mccarty-murillo.com',
            country: 'Orci Luctus Et',
            contact: '(320) 616-3915',
            name: 'Ultrices Posuere Cubilia'
        },
        service: 'Curae Donec',
        total: 5285,
        avatar: avatar2,
        invoiceStatus: 'Quisque Id Mi',
        balance: '-$202',
        dueDate: '02 Aug 2019'
        },
        {
        id: 5002,
        issuedDate: '21 Jun 2019',
        client: {
            address: 'Nulla Facilisi Etiam',
            company: 'Imperdiet Et Commodo',
            companyEmail: 'smithrachel@davis-rose.net',
            country: 'Vulputate Justo In',
            contact: '(435) 899-1963',
            name: 'Blandit Sit Amet'
        },
        service: 'Nonummy Id Imperdiet',
        total: 3668,
        avatar: avatar6,
        invoiceStatus: 'Feugiat Aenean Fermentum',
        balance: '$731',
        dueDate: '15 Dec 2019'
    },
    {
        id: 5003,
        issuedDate: '30 Dec 2019',
        client: {
            address: 'Risus Praesent Luctus',
            company: 'Venenatis Faucibus Nullam',
            companyEmail: 'scott96@mejia.net',
            country: 'Quis Que Amet',
            contact: '(254) 399-4728',
            name: 'Ipsum Primis In'
        },
        service: 'Faucibus Orci Luctus',
        total: 4372,
        avatar: '',
        invoiceStatus: 'Ultrices Posuere Cubilia',
        balance: '-$344',
        dueDate: '17 Sep 2019'
    },
    {
        id: 5004,
        issuedDate: '27 May 2019',
        client: {
            address: 'Curae Donec Quisque',
            company: 'Id Mi Vitae',
            companyEmail: 'cramirez@ross-bass.biz',
            country: 'Turpis Egestas Aliquam',
            contact: '(648) 500-4338',
            name: 'Fringilla Mauris Sit'
        },
        service: 'Amet Nibh Donec',
        total: 3198,
        avatar: avatar7,
        invoiceStatus: 'Sodales Urna Nec',
        balance: '-$253',
        dueDate: '16 Aug 2019'
    },
    {
        id: 5005,
        issuedDate: '30 Jul 2019',
        client: {
            address: 'Tellus Aenean Leo',
            company: 'Ligula Porttitor Euismod',
            companyEmail: 'arielberg@wolfe-smith.com',
            country: 'Phasellus Viverra Nulla',
            contact: '(896) 544-3796',
            name: 'Facilisi Cras Non'
        },
        service: 'Venenatis Tristique Dui',
        total: 5293,
        avatar: '',
        invoiceStatus: 'Velit Egestas Etiam',
        balance: 0,
        dueDate: '01 Aug 2019'
    },
    {
        id: 5006,
        issuedDate: '10 Jun 2019',
        client: {
            address: 'Pretium Quisque Nulla',
            company: 'Vestibulum Malesuada Primis',
            companyEmail: 'yrobinson@nichols.com',
            country: 'In Faucibus Orci',
            contact: '(236) 784-5142',
            name: 'Luctus Et Ultrices'
        },
        service: 'Posuere Cubilia Curae',
        total: 5612,
        avatar: avatar6,
        invoiceStatus: 'Suspendisse Pulvinar Augue',
        balance: '$883',
        dueDate: '12 Apr 2019'
    },
    {
        id: 5007,
        issuedDate: '01 Feb 2020',
        client: {
            address: 'Accumsan Odio Curabitur',
            company: 'Sociis Natoque Penatibus',
            companyEmail: 'tatejennifer@allen.net',
            country: 'Magnis Dis Parturient',
            contact: '(436) 717-2419',
            name: 'Montes Nascetur Ridiculus'
        },
        service: 'Mus Nulla Dui',
        total: 2230,
        avatar: avatar1,
        invoiceStatus: 'Fusce Feugiat Malesuada',
        balance: 0,
        dueDate: '19 Nov 2019'
    },
    {
        id: 5008,
        issuedDate: '22 Mar 2020',
        client: {
            address: 'Odio Sem Nec',
            company: 'Elit Maecenas Ut',
            companyEmail: 'gdurham@lee.com',
            country: 'Massa Quis Augue',
            contact: '(489) 946-3041',
            name: 'Luctus Et Ultrices'
        },
        service: 'Posuere Ac Ut',
        total: 2032,
        avatar: avatar8,
        invoiceStatus: 'Consequat Dui Nec',
        balance: 0,
        dueDate: '30 Nov 2019'
    },
    {
        id: 5009,
        issuedDate: '30 Nov 2019',
        client: {
            address: 'Nisi Vulputate Nonummy',
            company: 'Maecenas Tincidunt Lacus',
            companyEmail: 'jenny96@lawrence-thompson.com',
            country: 'Eget Tempor Cum',
            contact: '(274) 246-3725',
            name: 'Sociis Natoque Penatibus'
        },
        service: 'Magnis Dis Parturient',
        total: 3128,
        avatar: avatar3,
        invoiceStatus: 'Montes Nascetur Ridiculus',
        balance: 0,
        dueDate: '10 Sep 2019'
    },
    {
        id: 5010,
        issuedDate: '06 Jan 2020',
        client: {
            address: 'Mus Nulla Dui',
            company: 'Fusce Feugiat Malesuada',
            companyEmail: 'jgutierrez@jackson.com',
            country: 'Odio Sem Nec',
            contact: '(258) 211-5970',
            name: 'Elit Maecenas Ut'
        },
        service: 'Massa Quis Augue',
        total: 2060,
        avatar: avatar2,
        invoiceStatus: 'Luctus Et Ultrices',
        balance: 0,
        dueDate: '08 Dec 2019'
    },
    {
        id: 5011,
        issuedDate: '01 Jun 2019',
        client: {
            address: 'Posuere Ac Ut',
            company: 'Consequat Dui Nec',
            companyEmail: 'hunter14@jones.com',
            country: 'Nisi Vulputate Nonummy',
            contact: '(593) 965-4100',
            name: 'Maecenas Tincidunt Lacus'
        },
        service: 'Eget Tempor Cum',
        total: 4077,
        avatar: '',
        invoiceStatus: 'Sociis Natoque Penatibus',
        balance: 0,
        dueDate: '01 Feb 2020'
    },
    {
        id: 5012,
        issuedDate: '30 Oct 2019',
        client: {
            address: 'Magnis Dis Parturient',
            company: 'Montes Nascetur Ridiculus',
            companyEmail: 'pricetodd@johnson-jenkins.com',
            country: 'Mus Nulla Dui',
            contact: '(585) 829-2603',
            name: 'Fusce Feugiat Malesuada'
        },
        service: 'Odio Sem Nec',
        total: 2872,
        avatar: avatar4,
        invoiceStatus: 'Elit Maecenas Ut',
        balance: 0,
        dueDate: '18 Oct 2019'
    },
    {
        id: 5013,
        issuedDate: '05 Feb 2020',
        client: {
            address: 'Massa Quis Augue',
            company: 'Luctus Et Ultrices',
            companyEmail: 'perrydavid@chapman-rogers.com',
            country: 'Posuere Ac Ut',
            contact: '(527) 351-5517',
            name: 'Consequat Dui Nec'
        },
        service: 'Nisi Vulputate Nonummy',
        total: 3740,
        avatar: avatar10,
        invoiceStatus: 'Maecenas Tincidunt Lacus',
        balance: 0,
        dueDate: '01 Nov 2019'
    },
    {
        id: 5014,
        issuedDate: '01 Dec 2019',
        client: {
            address: 'Vestibulum Ante Ipsum',
            company: 'Primis In Faucibus',
            companyEmail: 'leahgriffin@carpenter.com',
            country: 'Orci Luctus Et',
            contact: '(628) 903-0132',
            name: 'Ultrices Posuere Cubilia'
        },
        service: 'Curae Donec Quisque',
        total: 3623,
        avatar: '',
        invoiceStatus: 'Sagittis Lacus Vel',
        balance: 0,
        dueDate: '23 Sep 2019'
    },
    {
        id: 5015,
        issuedDate: '16 Apr 2019',
        client: {
            address: 'Mauris Sit Amet',
            company: 'Massa Quis Enim',
            companyEmail: 'esparzadaniel@allen.com',
            country: 'Donec Pede Justo',
            contact: '(847) 396-9904',
            name: 'Fringilla Vel Aliquet'
        },
        service: 'Nec Eget Sem',
        total: 2477,
        avatar: avatar7,
        invoiceStatus: 'Quisque Rutrum Aenean',
        balance: 0,
        dueDate: '01 Apr 2019'
    },
    {
        id: 5016,
        issuedDate: '24 Jan 2020',
        client: {
            address: 'Imperdiet A Venenatis',
            company: 'Vitae Justo Nullam',
            companyEmail: 'todd34@owens-morgan.com',
            country: 'Dictum Felis Eu',
            contact: '(852) 249-4539',
            name: 'Pedem Malesuada'
        },
        service: 'Inceptos Hymenaeos Mauris',
        total: 3904,
        avatar: '',
        invoiceStatus: 'Ut Pharetra Augue',
        balance: '$951',
        dueDate: '30 Sep 2019'
    },
    {
        id: 5017,
        issuedDate: '24 Feb 2020',
        client: {
            address: 'Nec Dui Fusce',
            company: 'Feugiat A Tellus',
            companyEmail: 'roydavid@bailey.com',
            country: 'Phasellus Viverra Nulla',
            contact: '(917) 984-2232',
            name: 'Ac Enim In'
        },
        service: 'Tempor Cum Soluta',
        total: 3102,
        avatar: avatar1,
        invoiceStatus: 'Nobis Eleifend Option',
        balance: '-$153',
        dueDate: '25 Aug 2019'
    },
    {
        id: 5018,
        issuedDate: '29 Feb 2020',
        client: {
            address: 'Consequat Vitae Eleifend',
            company: 'Ac Leo Pellentesque',
            companyEmail: 'baldwinjoel@washington.com',
            country: 'Ultrices Posuere Cubilia',
            contact: '(670) 409-3703',
            name: 'Curae Nunc Sed'
        },
        service: 'Turpis Aenean Egestas',
        total: 2483,
        avatar: avatar5,
        invoiceStatus: 'Erat Volutpat Nullam',
        balance: 0,
        dueDate: '10 Jul 2019'
    },
    {
        id: 5019,
        issuedDate: '07 Aug 2019',
        client: {
            address: 'Orci Etiam Ultricies',
            company: 'Nisi Vulputate Nonummy',
            companyEmail: 'psmith@morris.info',
            country: 'Maecenas Tincidunt Lacus',
            contact: '(646) 263-0257',
            name: 'At Turpis Donec'
        },
        service: 'Posuere Felis Sed',
        total: 2825,
        avatar: avatar8,
        invoiceStatus: 'Lacus Curabitur At',
        balance: '-$459',
        dueDate: '14 Oct 2019'
    },
    {
        id: 5020,
        issuedDate: '10 May 2019',
        client: {
            address: 'Ipsum Primis In',
            company: 'Faucibus Orci Luctus',
            companyEmail: 'lori06@morse.com',
            country: 'Et Ultrices Posuere',
            contact: '(751) 213-4288',
            name: 'Cubilia Curae Mauris'
        },
        service: 'Viverra Dapibus Nulla',
        total: 2029,
        avatar: avatar4,
        invoiceStatus: 'Suscipit Ligula In',
        balance: 0,
        dueDate: '28 Mar 2019'
    },
    {
        id: 5021,
        issuedDate: '02 Apr 2019',
        client: {
            address: 'Lacus Nulla Fusce',
            company: 'Risus Aenean Auctor',
            companyEmail: 'zpearson@miller.com',
            country: 'Gravida Sem Praesent',
            contact: '(655) 649-7872',
            name: 'Id Ornare Imperdiet'
        },
        service: 'Sapien Urna Pretium',
        total: 3208,
        avatar: '',
        invoiceStatus: 'Nisl Ut Voluptate',
        balance: 0,
        dueDate: '06 Sep 2019'
    },
    {
        id: 5022,
        issuedDate: '02 May 2019',
        client: {
            address: 'Euismod Tincidunt Ut',
            company: 'Libero Venenatis Faucibus',
            companyEmail: 'strongpenny@young.net',
            country: 'Nullam Nulla Eros',
            contact: '(402) 935-0735',
            name: 'Elementum Eu Interdum'
        },
        service: 'Curabitur Ullamcorper Ultricies',
        total: 3077,
        avatar: '',
        invoiceStatus: 'Nisi Nam Ultrices',
        balance: 0,
        dueDate: '09 May 2019'
    },
    {
        id: 5023,
        issuedDate: '23 Mar 2020',
        client: {
            address: 'Libero Integer Nec',
            company: 'Orci Donec Vulputate',
            companyEmail: 'carrietorres@acosta.com',
            country: 'Arcu Libero Rutrum',
            contact: '(915) 448-6271',
            name: 'Ac Dui Suspendisse'
        },
        service: 'Faucibus Orci Luctus',
        total: 5578,
        avatar: avatar9,
        invoiceStatus: 'Et Ultrices Neque',
        balance: 0,
        dueDate: '23 Jul 2019'
    },
    {
        id: 5024,
        issuedDate: '28 Sep 2019',
        client: {
            address: 'Sodales Sed Tincidunt',
            company: 'Eu Felis Fusce',
            companyEmail: 'zjohnson@nichols-powers.com',
            country: 'Posuere Ac Ut',
            contact: '(817) 700-2984',
            name: 'Congue Quam Semper'
        },
        service: 'Libero Venenatis Faucibus',
        total: 2787,
        avatar: avatar1,
        invoiceStatus: 'Nullam Nulla Eros',
        balance: 0,
        dueDate: '25 Sep 2019'
    },
    {
        id: 5025,
        issuedDate: '21 Feb 2020',
        client: {
            address: 'Elementum Eu Interdum',
            company: 'Curabitur Ullamcorper Ultricies',
            companyEmail: 'kayla09@thomas.com',
            country: 'Nisi Nam Ultrices',
            contact: '(266) 611-9482',
            name: 'Libero Integer Nec'
        },
        service: 'Orci Donec Vulputate',
        total: 5591,
        avatar: '',
        invoiceStatus: 'Arcu Libero Rutrum',
        balance: 0,
        dueDate: '07 Jun 2019'
    },
    {
        id: 5026,
        issuedDate: '24 May 2019',
        client: {
            address: 'Ac Dui Suspendisse',
            company: 'Faucibus Orci Luctus',
            companyEmail: 'melvindavis@allen.info',
            country: 'Et Ultrices Neque',
            contact: '(739) 745-9728',
            name: 'Sodales Sed Tincidunt'
        },
        service: 'Eu Felis Fusce',
        total: 2783,
        avatar: avatar6,
        invoiceStatus: 'Posuere Ac Ut',
        balance: 0,
        dueDate: '22 Oct 2019'
    },
    {
        id: 5027,
        issuedDate: '13 Jan 2020',
        client: {
            address: 'Vestibulum Ante Ipsum',
            company: 'Primis In Faucibus',
            companyEmail: 'gjordan@fernandez-coleman.com',
            country: 'Orci Luctus Et',
            contact: '(682) 804-6506',
            name: 'Ultrices Posuere Cubilia'
        },
        service: 'Curae Nulla',
        total: 2719,
        avatar: '',
        invoiceStatus: 'Dapibus Ac Facilisis',
        balance: 0,
        dueDate: '04 Feb 2020'
    },
    {
        id: 5028,
        issuedDate: '18 May 2019',
        client: {
            address: 'Morbi Leo Risus',
            company: 'Porta Ac Consectetur',
            companyEmail: 'robertscott@garcia.com',
            country: 'Vestibulum At Eros',
            contact: '(775) 366-0411',
            name: 'Cras Justo Odio'
        },
        service: 'Dapibus Ac Facilisis',
        total: 3325,
        avatar: '',
        invoiceStatus: 'In Vulputate Eu',
        balance: '$361',
        dueDate: '02 Mar 2020'
    },
    {
        id: 5029,
        issuedDate: '29 Oct 2019',
        client: {
            address: 'Aenean Eu Leo',
            company: 'Quam Quisque Ligula',
            companyEmail: 'desiree61@kelly.com',
            country: 'Sagittis Purus Sit',
            contact: '(510) 536-6029',
            name: 'Amet Consectetur'
        },
        service: 'Adipiscing Elit Fusce',
        total: 3851,
        avatar: '',
        invoiceStatus: 'Dapibus Ac Facilisis',
        balance: 0,
        dueDate: '25 Aug 2019'
    },
    {
        id: 5030,
        issuedDate: '07 Apr 2019',
        client: {
            address: 'Mollis Nunc Sed',
            company: 'Id Semper Risus',
            companyEmail: 'jeffrey25@martinez-hodge.com',
            country: 'In Faucibus Orci',
            contact: '(253) 230-4657',
            name: 'Luctus Et Ultrices'
        },
        service: 'Posuere Cubilia Curae',
        total: 5565,
        avatar: '',
        invoiceStatus: 'Dapibus Ac Facilisis',
        balance: 0,
        dueDate: '06 Mar 2020'
    },
    {
        id: 5031,
        issuedDate: '21 Aug 2019',
        client: {
            address: 'Vestibulum Ante Ipsum',
            company: 'Primis In Faucibus',
            companyEmail: 'john77@anderson.net',
            country: 'Orci Luctus Et',
            contact: '(612) 546-3485',
            name: 'Ultrices Posuere Cubilia'
        },
        service: 'Curae Nulla',
        total: 3313,
        avatar: avatar3,
        invoiceStatus: 'Dapibus Ac Facilisis',
        balance: 0,
        dueDate: '09 Jun 2019'
    },
    {
        id: 5032,
        issuedDate: '31 May 2019',
        client: {
            address: 'Morbi Leo Risus',
            company: 'Porta Ac Consectetur',
            companyEmail: 'ywagner@jones.com',
            country: 'Vestibulum At Eros',
            contact: '(203) 601-8603',
            name: 'Cras Justo Odio'
        },
        service: 'Dapibus Ac Facilisis',
        total: 5181,
        avatar: '',
        invoiceStatus: 'In Vulputate Eu',
        balance: 0,
        dueDate: '22 Oct 2019'
    },
    {
        id: 5033,
        issuedDate: '12 Jul 2019',
        client: {
            address: 'Aenean Eu Leo',
            company: 'Quam Quisque Ligula',
            companyEmail: 'calvin07@joseph-edwards.org',
            country: 'Sagittis Purus Sit',
            contact: '(895) 401-4255',
            name: 'Amet Consectetur'
        },
        service: 'Adipiscing Elit Fusce',
        total: 2869,
        avatar: avatar1,
        invoiceStatus: 'Dapibus Ac Facilisis',
        balance: 0,
        dueDate: '22 Mar 2020'
    },
    {
        id: 5034,
        issuedDate: '10 Jul 2019',
        client: {
            address: 'Mollis Nunc Sed',
            company: 'Id Semper Risus',
            companyEmail: 'eric47@george-castillo.com',
            country: 'In Faucibus Orci',
            contact: '(602) 336-9806',
            name: 'Luctus Et Ultrices'
        },
        service: 'Posuere Cubilia Curae',
        total: 4836,
        avatar: '',
        invoiceStatus: 'Dapibus Ac Facilisis',
        balance: 0,
        dueDate: '22 Oct 2019'
    },
    {
        id: 5035,
        issuedDate: '20 Jul 2019',
        client: {
            address: 'Vestibulum Ante Ipsum',
            company: 'Primis In Faucibus',
            companyEmail: 'jamesjoel@chapman.net',
            country: 'Orci Luctus Et',
            contact: '(936) 550-1638',
            name: 'Ultrices Posuere Cubilia'
        },
        service: 'Curae Nulla',
        total: 4263,
        avatar: '',
        invoiceStatus: 'Dapibus Ac Facilisis',
        balance: '$762',
        dueDate: '12 Jun 2019'
    },
    {
        id: 5036,
        issuedDate: '19 Apr 2019',
        client: {
            address: 'Morbi Leo Risus',
            company: 'Porta Ac Consectetur',
            companyEmail: 'pwillis@cross.org',
            country: 'Vestibulum At Eros',
            contact: '(687) 660-2473',
            name: 'Cras Justo Odio'
        },
        service: 'Dapibus Ac Facilisis',
        total: 3171,
        avatar: avatar9,
        invoiceStatus: 'In Vulputate Eu',
        balance: '-$205',
        dueDate: '25 Sep 2019'
    }  
    ]
}

// ------------------------------------------------
// GET: Return Invoice List
// ------------------------------------------------
mock.onGet('/apps/invoice2/invoices').reply(config => {
  // eslint-disable-next-line object-curly-newline
  const { 
    q = '', 
    perPage = 10, 
    page = 1, 
    // status = null, 
    sort, sortColumn 
  } = config
  /* eslint-enable */

  const dataAsc = data.invoices.sort((a, b) => {
    if (a[sortColumn]) {
      return a[sortColumn] < b[sortColumn] ? -1 : 1
    } else {
      const splitColumn = sortColumn.split('.')
      const columnA = a[splitColumn[0]][splitColumn[1]]
      const columnB = b[splitColumn[0]][splitColumn[1]]
      return columnA < columnB ? -1 : 1
    }
  })

  const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

  const queryLowered = q.toLowerCase()

  const filteredData = dataToFilter.filter(invoice => {
    if (queryLowered.length && String('paid').includes(queryLowered) && invoice.balance === 0) {
      return invoice.balance === 0
    } else {
      /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
      return (
        (
          invoice.client.companyEmail.toLowerCase().includes(queryLowered) ||
          invoice.client.name.toLowerCase().includes(queryLowered) ||
          String(invoice.id).toLowerCase().includes(queryLowered) ||
          String(invoice.total).toLowerCase().includes(queryLowered) ||
          String(invoice.balance).toLowerCase().includes(queryLowered) ||
          invoice.dueDate.toLowerCase().includes(queryLowered)) 
        // &&
        // invoice.invoiceStatus.toLowerCase() === (status.toLowerCase() || invoice.invoiceStatus.toLowerCase())
      )
    }
  })
  /* eslint-enable  */

  return [
    200,
    {
      allData: data.invoices,
      total: filteredData.length,
      invoices: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page)
    }
  ]
})

// ------------------------------------------------
// GET: Return Single Invoice
// ------------------------------------------------
mock.onGet(/\/api\/invoice2\/invoices\/\d+/).reply(config => {
  // // Get event id from URL
  const invoiceId = Number(config.url.substring(config.url.lastIndexOf('/') + 1))

  const invoiceIndex = data.invoices.findIndex(e => e.id === invoiceId)
  const responseData = {
    invoice: data.invoices[invoiceIndex],
    paymentDetails: {
      totalDue: '$12,169.55',
      bankName: 'American Bank',
      country: 'United States',
      iban: 'ETD95476213874685',
      swiftCode: 'BR91905'
    }
  }
  return [200, responseData]
})

// ------------------------------------------------
// DELETE: Deletes Invoice
// ------------------------------------------------
mock.onDelete('/apps/invoice2/delete').reply(config => {
  // Get invoice id from URL
  let invoiceId = config.id

  // Convert Id to number
  invoiceId = Number(invoiceId)

  const invoiceIndex = data.invoices.findIndex(t => t.id === invoiceId)
  data.invoices.splice(invoiceIndex, 1)

  return [200]
})

// ------------------------------------------------
// GET: Return Clients
// ------------------------------------------------
mock.onGet('/api/invoice2/clients').reply(() => {
  const clients = data.invoices.map(invoice => invoice.client)
  return [200, clients.slice(0, 5)]
})
